import {SidebarMenuItem} from './SidebarMenuItem'
import {useGetUser} from '../../../../../app/tfi/store/userStore'
import {hasPermission, isAdministrator} from '../../../../../app/tfi/helpers'
import {ALL_PERMISSIONS} from '../../../../../app/tfi/helpers/consts'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useRealtimeStore} from '../../../../../app/tfi/store/realtimeStore'

const SidebarMenuMainLegacy = () => {
  const user = useGetUser((s) => s.user)
  const status = useGetUser((s) => s.status)
  const permissions = useGetUser((user) => user?.user?.permissions)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const isAgente = userGroups.includes('Agente')
  const isSupervisor = userGroups.includes('Supervisor')
  const unreadCount = useRealtimeStore((state) => state.sidebarCounters.unreadNotificationsCount)
  const openTicketsCount = useRealtimeStore((state) => state.sidebarCounters.openTicketsCount)
  const inboxUnreadCount = useRealtimeStore((state) => state.sidebarCounters.inboxUnreadCount)
  const policyChatUnreadCount = useRealtimeStore(
    (state) => state.sidebarCounters.policyChatUnreadCount
  )
  if (!permissions || !user || status !== 'user') return null

  return (
    <>
      {(isAdministrator(permissions) || isAgente || isSupervisor) &&
        hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
          <SidebarMenuItemWithSub to='/dashboard' title='Dashboards' fontIcon='bi-speedometer2' icon='element-plus'>
            <SidebarMenuItem to='/dashboard/policy' title='Dashboard based on status' hasBullet />
            <SidebarMenuItem to='/dashboard/executive' title='Dashboard based on commissions' hasBullet />
          </SidebarMenuItemWithSub>
        )}
      <SidebarMenuItem to='/calendar' title='Calendar' fontIcon='bi-calendar3' />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD) && (
        <SidebarMenuItem to='/leads' title='Leads' fontIcon='bi-person-vcard' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_TASKS) && (
        <SidebarMenuItem to='/kanban' title='Tasks' fontIcon='bi-kanban' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CAMPAIGNS) && (
        <SidebarMenuItemWithSub to='/campaigns' title='Campaigns' fontIcon='bi-megaphone' icon='element-plus'>
          <SidebarMenuItem to='/campaigns' title='Campaigns' hasBullet />
          <SidebarMenuItem to='/templates' title='Templates' hasBullet />
          <SidebarMenuItem to='/recipients' title='Recipients' hasBullet />
          <SidebarMenuItem to='/media-manager' title='Media Manager' hasBullet />
          <SidebarMenuItem to='/automations' title='Automations' hasBullet />
        </SidebarMenuItemWithSub>
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <SidebarMenuItem to='/users' title='Users' fontIcon='bi-people' />
      )}
      {(isAdministrator(permissions) || isSupervisor) && (
        <SidebarMenuItem to='/billing' title='Billing' fontIcon='bi-cash-coin' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <SidebarMenuItem to='/policies' title='Policies' fontIcon='bi-shield-check' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <SidebarMenuItem to='/quotes' title='Quotes' fontIcon='bi-clipboard-data' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <SidebarMenuItem to='/medicare-center' title='Medicare Center' fontIcon='bi-hospital' />
      )}
      {(hasPermission(permissions, ALL_PERMISSIONS.VIEW_SIGNATURE_FORMS) ||
        hasPermission(permissions, ALL_PERMISSIONS.VIEW_PDF_ENVELOPES)) && (
        <SidebarMenuItemWithSub to='/signature-forms' title='Digital Signatures' fontIcon='bi-file-earmark-check' icon='element-plus'>
          {hasPermission(permissions, ALL_PERMISSIONS.VIEW_SIGNATURE_FORMS) && (
            <SidebarMenuItem to='/signature-forms' title='Signature Forms' hasBullet />
          )}
          {hasPermission(permissions, ALL_PERMISSIONS.VIEW_PDF_ENVELOPES) && (
            <SidebarMenuItem to='/pdf-envelopes' title='PDF Signing' hasBullet />
          )}
        </SidebarMenuItemWithSub>
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <SidebarMenuItem to='/contacts' title='Contacts' fontIcon='bi-telephone-fill' />
      )}
      <SidebarMenuItem
        to='/tickets'
        title='Tickets'
        fontIcon='bi-ticket-perforated'
        badge={openTicketsCount > 0 ? openTicketsCount : undefined}
      />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION) && (
        <SidebarMenuItem to='/commissions' title='Commissions' fontIcon='bi-piggy-bank' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_RESOURCE_CENTER) && (
        <SidebarMenuItem to='/resource-center' title='Resource Center' fontIcon='bi-folder2-open' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_ACADEMY) && (
        <SidebarMenuItem to='/academy' title='Academy' fontIcon='bi-mortarboard' />
      )}
      <SidebarMenuItem
        to='/notifications'
        title='Notifications'
        fontIcon='bi-bell'
        badge={unreadCount > 0 ? unreadCount : undefined}
      />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_INTEGRATION) && (
        <SidebarMenuItem to='/integrations' title='Integrations' fontIcon='bi-diagram-3' />
      )}
      <SidebarMenuItem
        to='/inbox'
        title='Inbox'
        fontIcon='bi-chat-square-text'
        badge={inboxUnreadCount > 0 ? inboxUnreadCount : undefined}
      />
      <SidebarMenuItem
        to='/policychat'
        title='PolicyChat'
        fontIcon='bi-chat-heart'
        badge={policyChatUnreadCount > 0 ? policyChatUnreadCount : undefined}
      />
    </>
  )
}

export {SidebarMenuMainLegacy}
